<template lang="html">
  <section class="px-4 lg:px-0 w-full max-w-xl">
    <div v-if="type === 'buy'">
      <div
        class="flex flex-col gap-1 sm:flex-row justify-between text-sm sm:text-base lg:text-sm xl:text-md text-grey-900 dark:text-gold-50 font-bold"
      >
        <div :class="{ 'text-gold-500': prevPrice && prevPrice !== price }">
          Totalpris:
          <div class="text-xl">{{ $filters.formatNumber(price) }},-</div>
          <div
            class="text-sm text-gray-900 font-light line-through"
            v-if="prevPrice && prevPrice !== price"
          >
            Ordinærpris: {{ prevPrice }},-
          </div>
        </div>
        <div class="h-12 w-px bg-gray-300 hidden sm:block"></div>
        <div>
          Månedspris
          <div class="text-xl">{{ $filters.formatNumber(mndprice) }},-</div>
        </div>
        <div class="h-12 w-px bg-gray-300 hidden sm:block"></div>
        <div>
          Totalpris ved finansiering
          <div class="text-xl whitespace-nowrap" id="total-price">
            {{ $filters.formatNumber(totalPrice) }} ,-
          </div>
        </div>
      </div>
      <div
        class="text-grey-900 dark:text-gold-50 text-xs lg:text-base font-light my-1 lg:my-5 leading-normal"
      >
        ved en egenkapital på
        <strong class="font-semibold">{{
          $filters.formatNumber(capital)
        }}</strong>
        ,- med {{ years }} års nedbetaling.<br />
        Nominell rente:
        <strong class="font-semibold"
          >{{ $filters.formatNumber(nominalInterest) }}%</strong
        >. <br />
        Effektiv rente:
        <strong class="font-semibold"
          >{{ $filters.formatNumber(effectiveInterest) }}%</strong
        >.<br />
      </div>
    </div>
    <div v-else-if="type == 'leasing'">
      <div class="text-gold-500 font-light text-sm lg:text-md lg:mt-2">
        Leasing
      </div>
      <div
        class="text-grey-900 dark:text-gold-50 text-sm lg:text-lg mt-0.5 lg:mt-3"
      >
        Fra {{ $filters.formatNumber(mndprice) }} ,- pr mnd
      </div>
      <div class="flex flex-row gap-6 lg:flex-col text-xs lg:text-base">
        <div class="lg:mt-2 text-grey-900 dark:text-gold-50">
          Kilometer:
          {{ $filters.formatNumber(kilometer_limit) }} km
        </div>
        <div class="lg:mt-1 text-grey-900 dark:text-gold-50">
          Forskudd:
          {{ $filters.formatNumber(upfront_cost) }} ,-
        </div>
      </div>
      <div
        class="text-grey-900 dark:text-gold-50 text-sm lg:text-xl font-bold lg:mt-6"
        id="total-price"
      >
        <div v-if="prevTotalPrice">
          <div class="text-gold-500">
            Totalpris:
            <span class="text-xl"
              >{{ $filters.formatNumber(totalPrice) }},-</span
            >
          </div>
          <div class="text-sm text-gray-900 font-light line-through">
            Ordinærpris: {{ $filters.formatNumber(prevTotalPrice) }} ,-
          </div>
        </div>
        <div v-else>Totalpris: {{ $filters.formatNumber(totalPrice) }} ,-</div>
      </div>
    </div>
    <div v-else>
      <div class="text-gold-500 font-light text-sm lg:text-md lg:mt-2">
        Abonnement
      </div>
      <div class="text-grey-900 dark:text-gold-50 text-sm lg:text-lg lg:my-3">
        fra {{ $filters.formatNumber(mndprice) }} ,- pr mnd
      </div>
      <div class="text-grey-900 dark:text-gold-50 text-sm lg:text-xl font-bold">
        <div v-if="prevTotalPrice">
          <div class="text-gold-500">
            Totalpris:
            <span class="text-xl"
              >{{ $filters.formatNumber(totalPrice) }},-</span
            >
          </div>
          <div class="text-sm text-gray-900 font-light line-through">
            Ordinærpris: {{ $filters.formatNumber(prevTotalPrice) }} ,-
          </div>
        </div>
        <div v-else>Totalpris: {{ $filters.formatNumber(totalPrice) }} ,-</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FinancialCalculatorOutput',
  data() {
    return {
      type: parent.location.hash.replace('#', '') || 'buy',
      price: 0,
      mndprice: 0,
      capital: 0,
      effectiveInterest: 0,
      totalPrice: 0,
      prevTotalPrice: 0,
      years: 0,
      nominalInterest: 0,
      disclaimer: '',
      kilometer_limit: null,
      upfront_cost: 0,
    };
  },
  mounted() {
    this.emitter.on('update-calculations', (data) => {
      for (const key in data) {
        const n = data[key];
        if (key === 'type' || key === 'disclaimer') {
          this[key] = n;
        } else {
          this[key] = n % 1 === 0 ? n : n.toFixed(2);
        }
      }
    });
  },
};
</script>
